import PropTypes from "prop-types";
import { useIntersection } from "./interSectionObserver";
import React, { useRef, useState } from "react";
function ProgressiveRenderer(props) {
  const {
    children
  } = props;
  const ref = useRef();
  const [isDataVisible, setDataVisibilty] = useState(false);
  useIntersection(ref, () => {
    setDataVisibilty(true);
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, isDataVisible ? children : /*#__PURE__*/React.createElement(React.Fragment, null));
}
ProgressiveRenderer.propTypes = {
  children: PropTypes.node.isRequired
};
export { ProgressiveRenderer };